import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent, moduleTypeNames } from "../../../framework/core/mvvm/module_base";
import ClubGameSettingView from "./club_game_setting_view";
import ModuleManager from "../../../framework/core/module_manager";
import ClubRuleMgrModule from "./club_rule_manager_module";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("ClubGameSettingModule")
export default class ClubGameSettingModule extends ModuleBase<ClubGameSettingView,null> {

    private gameData : any = null;

    constructor(){
        super();
        this.layer = ViewLayer.Mid;
        this.modelType = null;
        this.viewType = ClubGameSettingView;
        this.needViewMask = true
        this.clickAnywhereClose = false;
        this.windowPrefabResPath = "package/club/module/club_game_setting"
    }

    onShow(intentData : any){

        if(intentData){

            this.view.deleteButton.node.active = intentData.source == "manager";

            this.gameData = intentData.gameData;
        }

    }

    @bindButtonClickEvent("delete")
    onDelete(){

        //this.gameData;

        this.hide();

        //返回
    }

    @bindButtonClickEvent("save")
    onSave(){


        let betNum = this.view.betNumEditorBox.string;
        //返回俱乐部大厅
        this.hide();
    }

    @bindButtonClickEvent("return")
    onReturn(){

        //返回玩法管理..        
        ModuleManager.instance.showModule(ClubRuleMgrModule,null,()=>{
            this.hide();
        });
    }
    
      
    @bindButtonClickEvent("close")
    onClose(){

        this.hide();
    }
}
